import Spinner from "./Spinner";

import './ContentLoadingSpinner.sass';

const ContentLoadingSpinner = () => {
    return (
        <div className='d-flex justify-content-center content-loading-spinner' style={{margin: '5rem 0'}}>
            <div><Spinner /></div>
        </div>
    );
};

export default ContentLoadingSpinner;